export default "__VITE_ASSET__Cqxara$9__"